var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", { staticClass: "clearfix" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "el-form",
                {
                  staticClass: "filter-form flex-form",
                  attrs: {
                    inline: true,
                    size: "small",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.query.spuName,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "spuName", $$v)
                          },
                          expression: "query.spuName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品ID：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.query.spuId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "spuId", $$v)
                          },
                          expression: "query.spuId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "展示分类：" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth",
                        attrs: {
                          options: _vm.displayCategories,
                          props: _vm.cascaderProps,
                          placeholder: "请选择",
                          clearable: "",
                          "show-all-levels": true,
                          separator: " / ",
                        },
                        on: { change: _vm.handleDisplayCategoryChange },
                        model: {
                          value: _vm.query.showCateId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "showCateId", $$v)
                          },
                          expression: "query.showCateId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品分类：" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth",
                        attrs: {
                          options: _vm.categories,
                          props: _vm.cascaderProps,
                          placeholder: "请选择",
                          clearable: "",
                          "show-all-levels": true,
                          separator: " / ",
                        },
                        on: { change: _vm.handleCategoryChange },
                        model: {
                          value: _vm.query.cateId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "cateId", $$v)
                          },
                          expression: "query.cateId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台上下架：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "status", $$v)
                            },
                            expression: "query.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "上架", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "下架", value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺ID：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入店铺ID", clearable: "" },
                        on: { input: _vm.handleStoreIdInput },
                        model: {
                          value: _vm.query.storeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "storeId", $$v)
                          },
                          expression: "query.storeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序方式：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.orderBy,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "orderBy", $$v)
                            },
                            expression: "query.orderBy",
                          },
                        },
                        _vm._l(_vm.sortOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品编码：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入商品编码", clearable: "" },
                        model: {
                          value: _vm.query.spuCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "spuCode", $$v)
                          },
                          expression: "query.spuCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "no-wrap-item",
                      attrs: { label: "创建时间：" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "date-range no-wrap" },
                        [
                          _c("el-date-picker", {
                            staticClass: "mr8",
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "开始时间",
                            },
                            model: {
                              value: _vm.query.createTimeStart,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "createTimeStart", $$v)
                              },
                              expression: "query.createTimeStart",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "range-sep" }, [
                            _vm._v("-"),
                          ]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            staticClass: "ml8",
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "结束时间",
                            },
                            model: {
                              value: _vm.query.createTimeEnd,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "createTimeEnd", $$v)
                              },
                              expression: "query.createTimeEnd",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "no-wrap-item",
                      attrs: { label: "最后更新时间：" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "date-range no-wrap" },
                        [
                          _c("el-date-picker", {
                            staticClass: "mr8",
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "开始时间",
                            },
                            model: {
                              value: _vm.query.updateTimeStart,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "updateTimeStart", $$v)
                              },
                              expression: "query.updateTimeStart",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "range-sep" }, [
                            _vm._v("-"),
                          ]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            staticClass: "ml8",
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "结束时间",
                            },
                            model: {
                              value: _vm.query.updateTimeEnd,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "updateTimeEnd", $$v)
                              },
                              expression: "query.updateTimeEnd",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("添加")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "商品ID", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "48px", height: "48px" },
                          attrs: {
                            src: scope.row.abbreviationImage || scope.row.image,
                            "preview-src-list": [
                              scope.row.abbreviationImage || scope.row.image,
                            ],
                            fit: "cover",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spuCode",
                  label: "商品编码",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spuName",
                  label: "商品名称",
                  "min-width": "220",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  label: "排序",
                  "min-width": "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              scope.row.sort === null ||
                                scope.row.sort === undefined ||
                                scope.row.sort === ""
                                ? "-"
                                : scope.row.sort
                            ) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "店铺名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brandName",
                  label: "商品品牌",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否必选", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.isMust ? "是" : "否") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cateName",
                  label: "商品分类",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "labelName", label: "标签", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "otPrice", label: "原价", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v("￥" + _vm._s(scope.row.otPrice || 0))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "price", label: "售价", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v("￥" + _vm._s(scope.row.price || 0))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "库存", "min-width": "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品状态", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "active-text": "上架",
                            "inactive-text": "下架",
                          },
                          on: {
                            change: function (val) {
                              return _vm.handleStatusChange(scope.row.id, val)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "最后更新时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "140", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopy(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.handleSyncData(scope.row)
                              },
                            },
                          },
                          [_vm._v("数据同步")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-link",
                          {
                            attrs: { type: "danger", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-link",
                          {
                            attrs: { type: "danger", underline: false },
                            on: {
                              click: function ($event) {
                                return _vm.syncDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("同步删除")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageInfo.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.pageInfo.limit,
                  total: _vm.pageInfo.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请选择需要同步的店铺",
            visible: _vm.syncDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.syncDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                multiple: "",
                placeholder: "请选择店铺",
                filterable: "",
              },
              model: {
                value: _vm.selectedStoreKeys,
                callback: function ($$v) {
                  _vm.selectedStoreKeys = $$v
                },
                expression: "selectedStoreKeys",
              },
            },
            _vm._l(_vm.syncStoreData, function (store) {
              return _c("el-option", {
                key: store.key,
                attrs: { label: store.value, value: store.key },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.syncDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmSyncData },
                },
                [_vm._v("确认同步")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }